module.exports = __webpack_public_path__ + "img/AmKienberg.d3ac03c2.jpg";